export class CaixaResponse {
    public codUsuarioIni: number;
    public codigo: number;
    public codigoEmpresa: number;
    public dataFechamento: Date | null;
    public dataInicio: Date | null;
    public numeroCaixa: number;
    public valor: number;
}